export default "__VITE_ASSET__BBB0GIUf__"